import { action, observable, makeObservable } from "mobx";
import categoriesAPI from "./api";
import client from "../session/apiClient";

export default class GoogleAttributesStore {
    isLoading = false;

    loaded = false;

    attributes = [];

    attributesError = null;

    constructor() {
        makeObservable(this, {
            isLoading: observable,
            loaded: observable,
            attributes: observable,
            attributesError: observable,
            loadAllAttributes: action,
            loadAttributesForLocation: action,
            onAttributesLoaded: action.bound,
            onAttributesError: action.bound
        });
    }

    loadAllAttributes() {
        this.isLoading = true;
        this.attributesError = null;
        return client.get("/v5/listingManagement/google/listAllAttributes")
            .then(this.onAttributesLoaded)
            .catch(this.onAttributesError)
    }

    loadAttributesForLocation(locationId) {
        this.isLoading = true;
        this.attributesError = null;
        return client.get("/v5/listingManagement/google/listAttributesForLocation?", {params: {locationId}})
            .then(this.onAttributesLoaded)
            .catch(this.onAttributesError)
    }

    onAttributesLoaded(resp) {
        this.attributes = resp.data;
        this.isLoading = false;
        this.loaded = true;
        return this.attributes;
    }

    onAttributesError(error) {
        if (error.response.status === 404) {
            this.attributesError = "Attributes can only be retrieved with a valid Google credential for a location." +
                "Please add a Google account to the External Logins page (under My Account) for this location to enable attributes."
        } else {
            this.attributesError = "Unknown error: '" + error.response.data + "' please contact support and provide them with this message."
        }
        this.attributes = [];
        this.isLoading = false;
        this.loaded = true;
        return this.attributes;
    }

    cmAttributeToGoogleAttribute = (cmAtt) => {
        //assumes attributes are loaded. Since all attributes are loaded we will definitely find something
        return this.attributes.filter(googleAtt => googleAtt.attributeId === cmAtt.attributeId)[0]
    }

    search = (query) => {
        const attributes = this.availableGoogleAttributes.map(att => att.displayName);
        const lowercase = query.toLowerCase();
        return attributes.filter(att => att.toLowerCase().includes(lowercase));
    };
}